import { shellProjectsAPI } from "@/views/ShellProjects/api";

export const getAllProjects = async (params) => {
  try {
    const res = await shellProjectsAPI.getList(params);
    return res?.data;
  } catch (e) {}
};
export const updateProject = async (body) => {
  try {
    const res = await shellProjectsAPI.updateShellProject(body);
    return res?.data;
  } catch (e) {}
};
export const getProjectInfo = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getProjectInfo(project_id);
    return res;
  } catch (e) {}
};
export const updProjectInfo = async (body) => {
  try {
    const res = await shellProjectsAPI.updProjectInfo(body);
    return res;
  } catch (e) {}
};
export const getProjectTypes = async () => {
  try {
    const res = await shellProjectsAPI.getProjectTypes();
    return res?.data;
  } catch (e) {}
};
export const getEmployeeList = async () => {
  try {
    const res = await shellProjectsAPI.getEmployeeList();
    return res?.data;
  } catch (e) {}
};

export const getEntrancesBlockInfo = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getEntrancesBlockInfo(project_id);
    return res?.data;
  } catch (e) {}
};
export const updEntrancesBlockInfo = async (body) => {
  try {
    const res = await shellProjectsAPI.updEntrancesBlockInfo(body);
    return res?.data;
  } catch (e) {}
};
export const getContractorsList = async () => {
  try {
    const res = await shellProjectsAPI.getContractors();
    return res?.contractors;
  } catch (e) {}
};

export const getEmployeesListByContractorId = async (contractor_id) => {
  try {
    const res = await shellProjectsAPI.getEmployeesListByContractorId(
      contractor_id
    );
    return res?.data;
  } catch (e) {}
};

export const getPerformersBlockInfo = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getEntrancesBlockInfo(project_id);
    return res?.data;
  } catch (e) {}
};

export const updateShellProjectPerfomancer = async (body) => {
  try {
    const res = await shellProjectsAPI.updateShellProjectPerfomancer(body);
    return res?.data;
  } catch (e) {}
};

export const getPerformersByProjectId = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getPerformersByProjectId(project_id);
    return res?.data;
  } catch (e) {}
};

export const getAssignTypes = async (project_id) => {
  try {
    const res = await shellProjectsAPI.getAssignTypes();
    return res?.data;
  } catch (e) {}
};

export const deleteShellProjectPerfomancer = async (body) => {
  const res = await shellProjectsAPI.deleteShellProjectPerfomancer(body);
  return res?.data;
};

export const copyPasteEntranceProperties = async (body) => {
  const res = await shellProjectsAPI.copyPasteEntranceProperties(body);
  return res?.data;
}

export const getProjectsById = async (project_id) => {
  const res = await shellProjectsAPI.getProjectsById(project_id);
  return res?.data;
}
export const projectsColumns = [
  {
    name: "project_id",
    field: "project_id",
    label: "ID",
    align: "center",
  },
  {
    name: "project_name",
    field: "project_name",
    label: "Наименование",
    align: "left",
    headerStyle: "width: 300px",
    width: "300px",
  },
  {
    name: "project_short_name",
    field: "project_short_name",
    label: "Короткое Наименование",
    align: "left",
  },
  {
    name: "project_type_id",
    field: "project_type_name",
    label: "Тип",
    align: "left",
    headerStyle: "width: 120px",
    style: "width: 120px",
  },
  {
    name: "resident_name",
    field: "resident_name",
    label: "ЖК",
    align: "left",
    headerStyle: "width: 200px",
    style: "width: 200px",
  },
  {
    name: "entrances",
    field: "entrances",
    label: "Подъезды",
    align: "center",
    headerStyle: "width: 100px",
    style: "width: 100px",
  },
  {
    name: "avans",
    field: "avans",
    label: "Сумма аванса",
    align: "right",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "start_date",
    field: "start_date",
    label: "Дата начала",
    align: "right",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "finish_date",
    field: "finish_date",
    label: "Дата окончания",
    align: "right",
    headerStyle: "width: 150px",
    style: "width: 150px",
  },
  {
    name: "document",
    field: "document",
    label: "Документ",
    align: "center",
  },
  {
    name: "edit",
    field: "edit",
    label: "",
    align: "center",
  },
];
export const entrancesColumns = [
  {
    name: "project_entrance_id",
    field: "project_entrance_id",
    label: "ID",
    align: "center",
  },
  {
    name: "entrance",
    field: "entrance",
    label: "Подъезд №",
    align: "center",
  },
  {
    name: "block_name",
    field: "block_name",
    label: "Блок",
    align: "center",
  },
];

export const performersColumns = [
  {
    name: "employee_fio",
    field: "employee_fio",
    label: "Исполнитель",
    align: "left",
  },
  {
    name: "assign_type_name",
    field: "assign_type_name",
    label: "Позиция",
    align: "left",
  },
  {
    name: "contractor_name",
    field: "contractor_name",
    label: "Компания",
    align: "left",
  },
  {
    name: "edit",
    field: "edit",
    label: "",
    align: "center",
  },
];
